var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIconGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5880_2414",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16C13.1423 16 16.5 12.6423 16.5 8.5C16.5 4.35775 13.1423 1 9 1C4.85775 1 1.5 4.35775 1.5 8.5C1.5 12.6423 4.85775 16 9 16Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5V11.5M6 8.5H12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5880_2414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.5H18V17.5H0V-0.5Z",
    fill: "#EAA827"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconGroup);
export default __webpack_public_path__ + "static/media/add-icon-group.64c1a066972f0561fd9389deb20be2f5.svg";
export { ForwardRef as ReactComponent };